import React from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { CheckCircleIcon, FileTextIcon, PartyPopperIcon } from 'lucide-react';

/**
 * ModuleCompletedWidget - Celebration widget shown when a module is completed
 */
const ModuleCompletedWidget = ({
  moduleTitle,
  moduleNumber,
  onViewModule,
  disabled = false,
  isLastModule = false,
}) => {
  const intl = useIntl();

  return (
    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-950/20 dark:to-teal-950/20 border-2 border-emerald-200 dark:border-emerald-800 rounded-xl p-6 space-y-4">
      {/* Success Icon */}
      <div className="flex items-center justify-center">
        <div className="h-16 w-16 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
          <CheckCircleIcon className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
        </div>
      </div>

      {/* Congratulations Message */}
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-succession-text-primary">
          🎉 {intl.formatMessage({ id: 'succession.plans.module_completed_widget_title' }, { number: moduleNumber })}
        </h3>
        <p className="text-sm text-succession-text-secondary">
          {intl.formatMessage({ id: 'succession.plans.module_completed_widget_finished' }, { title: moduleTitle })}
        </p>
      </div>

      {/* Information */}
      <div className="bg-white/50 dark:bg-black/20 rounded-lg p-4 space-y-2">
        <p className="text-sm text-succession-text-primary">
          {intl.formatMessage({ id: 'succession.plans.module_completed_widget_progress' })}
        </p>
        {!isLastModule && (
          <p className="text-sm text-succession-text-secondary">
            {intl.formatMessage({ id: 'succession.plans.module_completed_widget_review' })}
          </p>
        )}
        {isLastModule && (
          <p className="text-sm text-succession-text-secondary">
            {intl.formatMessage({ id: 'succession.plans.module_completed_widget_final' })}
          </p>
        )}
      </div>

      {/* View Module Button - different text for last module */}
      <Button
        onClick={onViewModule}
        disabled={disabled}
        className="w-full gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"
        size="lg"
      >
        {isLastModule ? (
          <>
            <PartyPopperIcon className="h-4 w-4" />
            {intl.formatMessage({ id: 'succession.plans.module_completed_widget_view_plan' })}
          </>
        ) : (
          <>
            <FileTextIcon className="h-4 w-4" />
            {intl.formatMessage({ id: 'succession.plans.module_completed_widget_continue' })}
          </>
        )}
      </Button>

      {/* Next Steps - only show if not last module */}
      {!isLastModule && (
        <p className="text-xs text-center text-succession-text-muted">
          {intl.formatMessage({ id: 'succession.plans.module_completed_widget_ready' })}
        </p>
      )}
    </div>
  );
};

export default ModuleCompletedWidget;

